<template>
  <div>
    <div v-if="filteredDataset.length > 0">
      <table class="table table-striped is-narrow">
        <thead>
        <tr>
          <th>{{$t('users.roles.role')}}</th>
          <th>{{$t('facility.inputs.entity')}}</th>
          <th v-if="editable"></th>
        </tr>
        </thead>
        <tbody>
        <tr style="height:65px" v-for="(item, index) in filteredDataset" :key="index">
          <td class="align-middle dataset__label">
            <va-popover
              :message="item.description || $t('roles.no_description')"
              placement="right"
            >
              <div class="pr-3">
                <span>{{$t(`roles.${item.id}`, item.name)}}</span>
                &nbsp;
                <i class="cursor-help fa fa-question-circle"></i>
              </div>
            </va-popover>
          </td>
          <td class="align-middle tag__role__item">
              <span v-if="!isEditingEntity || editingRow !== index">
                <div v-if="item.entities.length > 0">
                  <div v-if="item.entities.length > limitItems">
                    <div class="custom-tooltip-tag tag-role" v-for="(entity, index) in getFirstNItems(item.entities, limitItems)" :key="index">
                      {{formatedEntityLabel(entity)}}
                    </div>
                    <span @click="openAllEntities(item)" class="tag-role clickable">
                      {{$t('users.roles.actions.show_more')}} {{ item.entities.length - limitItems}}..
                    </span>
                  </div>
                  <div v-else>
                    <div class="custom-tooltip-tag tag-role" v-for="(entity, index) in item.entities" :key="index">
                      {{entity.name}}
                    </div>
                  </div>
                </div>
                <div v-else>
                  {{ $t('users.roles.without_entity') }}
                </div>
              </span>
            <div v-if="isEditingEntity && editingRow === index">
              <div class="form-group" style="margin-bottom:0rem;">
                <div class="input-group clearable-filter">
                  <multiselect
                    :options="availableEntities"
                    :value="editingEntities"
                    @select="handleSelect"
                    @remove="handleDeselect"
                    track-by="id"
                    label="name"
                    select-label=""
                    deselect-label="×"
                    :placeholder="$t('agenda.screenings.labels.all_entities')"
                    :allow-empty="true"
                    :multiple="true"
                    :searchable="true"
                    :close-on-select="false"
                    :limit="limitItems">
                    <template slot="tag" slot-scope="{ option, remove }">
                        <span class="custom__tag">
                          <span>{{ option.name }}&nbsp;
                            <span v-if="option.entities && Array.isArray(option.entities)">{{$t('users.roles.custom_clusters_label', {number: option.entitiesWithRoles})}}</span>
                          </span>
                          <i @click="remove(option)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                        </span>
                    </template>
                    <template slot="option" slot-scope="props">
                        <span class="option__name">
                          {{ props.option.name }}
                          <span v-if="props.option.entities && Array.isArray(props.option.entities)">{{$t('users.roles.custom_clusters_label', {number: props.option.entitiesWithRoles})}}</span>
                          <span v-else-if="props.option.cities && props.option.cities.length > 0">({{formatedEntityLabel(props.option)}})</span>
                        </span>
                    </template>
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="editingEntities.length" @mousedown.prevent.stop="editingEntities = []"></div>
                    </template>
                    <span slot="noResult">{{$t('patients.noResults')}}</span>
                  </multiselect>
                </div>
              </div>
              <!--<small>Ao selecionar um agrupamento será dada a função para as entidades do agrupamento que o utilizador possui permissões.</small>-->
            </div>
          </td>
          <td v-if="editable" class="align-middle">
            <div class="d-flex justify-content-end">
              <a v-if="!isEditingEntity && item.isEditable" href="#" @click.prevent="editUserEntityRole(item, index)">
                <i class="fa fa-pencil"></i>
              </a>
              <va-button
                v-if="isEditingEntity && editingRow === index"
                class="btn-cancel mr-2"
                @click.prevent="cancelEdit(item.id, index)">
                {{ $t('users.roles.actions.cancel') }}
              </va-button>
              <va-button
                v-if="isEditingEntity && editingRow === index"
                class="mr-2"
                @click.prevent="saveUserEntityRole(item)">
                {{ $t('users.roles.actions.save') }}
              </va-button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <div v-if="this.query !== ''" class="d-flex justify-content-center pt-4">
        <b>{{$t('users.roles.no_roles_found')}}</b>
      </div>
      <div v-else class="d-flex justify-content-center pt-4">
        <b> {{$t('users.roles.no_entities')}} </b>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-2" v-if="editable && shouldDisplayViewAllOption">
      <a href="#" @click.prevent="toogleViewAll">
        <span v-if="!viewAll">{{$t('users.roles.view_all')}}</span>
        <span v-else>{{$t('users.roles.hide')}}</span>
      </a>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import EntitiesByRoleFullDetails from './EntitiesByRoleFullDetails'
import DynamicSizeMixin from '../../Helpers/DynamicSizeMixin'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import { sortById, sortByName, sortByEntities } from './utils/sorters'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'

export default {
  props: {
    roles: {
      type: Array,
      required: true
    },
    subRoles: {
      type: Array,
      required: false
    },
    query: {
      type: String,
      required: false
    },
    limitItems: {
      type: Number,
      required: false,
      default: 3
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    clusters: {
      type: Array,
      required: false,
      default: () => []
    },
    isViewMode: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    Multiselect,
    EntitiesByRoleFullDetails
  },
  data () {
    return {
      isEditingEntity: false,
      viewAll: false,
      editingRow: -1,
      availableEntities: [],
      showFullEntities: false,
      editingEntities: [],
      dataset: [],
      datasetAvailableEntitiesByRole: [],
      clustersCopy: []
    }
  },
  mixins: [
    DynamicSizeMixin,
    MultiselectLabelFormatter
  ],
  mounted () {
    this.generateDataset()
    this.generateAvailableEntititiesByRole()
  },
  methods: {
    toogleViewAll: function () {
      this.viewAll = !this.viewAll
    },
    getNumberEntitiesWithPermissions: function (entitiesIds, roles) {
      return entitiesIds.filter(entityId => {
        return this.authUserRoles.some(r => {
          return (r.entity_id === entityId || r.entity_id === null) && roles.includes(r.role_id)
        }) && this.filteredAuthUserRoles.some(ur => ur.entity_id === entityId || ur.entity_id === null)
      }).length
    },
    generateAvailableEntititiesByRole: function () {
      this.authUserRoles.forEach(userRole => {
        let index = this.datasetAvailableEntitiesByRole.findIndex(item => item.roleId === userRole.role_id)
        if (index === -1) {
          this.datasetAvailableEntitiesByRole.push({
            roleId: userRole.role_id,
            entitiesIds: userRole.entity_id === null ? this.authEntities.map(item => item.id) : [userRole.entity_id]
          })
        } else {
          this.datasetAvailableEntitiesByRole[index].entitiesIds.push(userRole.entity_id)
        }
      })
    },
    generateDataset: function () {
      this.dataset = []
      // Para cada role do utilizador que está a editar
      this.authRoles.forEach(role => {
        let index = this.dataset.findIndex(item => item.id === role.id)
        // Se não encontrar um index no dataset para cada um registo no dataset cria
        if (index === -1) {
          this.dataset.push({
            id: role.id,
            name: role.name,
            description: role.description,
            isEditable: true,
            entities: []
          })
        }
      })
      // Para cada subrole das roles do utilizador que está a editar
      this.subRoles.forEach(role => {
        role.subroles.forEach(subrole => {
          let index = this.dataset.findIndex(item => item.id === subrole.id)
          // Se não encontrar um index no dataset para cada um registo no dataset cria
          if (index === -1) {
            this.dataset.push({
              id: subrole.id,
              name: subrole.name,
              description: subrole.description,
              isEditable: true,
              entities: [],
              availableEntities: []
            })
          }
        })
      })
      // Para cada role do utilizador para qual está a editar
      this.roles.forEach(userRole => {
        let index = this.dataset.findIndex(item => item.id === userRole.role.id)
        // Se encontrar um indice de role para esse utilizador adiciona as entidades dessa role
        if (index >= 0) {
          let item = this.dataset[index]
          if (userRole.entity === null) {
            // Para cada entidade que eu tenho acesso, se ela ainda não estiver na lista
            this.authEntities.forEach(entity => {
              if (!item.entities.some(e => e.id === entity.id)) {
                item.entities.push({
                  ...entity,
                })
              }
            })
            item.isEditable = false
          } else {
            let hasPermission = this.authUserRoles.some(ur => ur.role_id === item.id && (ur.entity_id === userRole.entity.id || ur.entity_id === null))
            item.entities.push({
              ...userRole.entity,
              $isDisabled: !hasPermission
            })
          }
        } else {
          // Se não encontrar a role
          this.dataset.push({
            ...userRole.role,
            isEditable: false,
            entities: [{
              ...userRole.entity
            }]
          })
        }
      })
      this.dataset.sort(sortByEntities || sortByName)
    },
    handleDeselect: function (item) {
      if (this.availableEntities.some(entity => entity.id === item.id && !entity.$isDisabled)) {
        this.editingEntities = this.editingEntities.filter(entity => entity.id !== item.id)
      }
    },
    handleSelect: function (item) {
      this.editingEntities.push(item)
    },
    openAllEntities: function (role) {
      this.isEditingEntity = false
      this.showFullEntities = true
      this.$emit('showEntitiesForRoleModal', {
        entities: role.entities,
        role
      })
    },
    getFirstNItems: function (arr, n) {
      return arr.slice(0, n)
    },
    getUserEntitiesByRole: function (roleId) {
      return this.roles.filter(item => {
        return item.role.id === roleId && this.availableEntitiesByRole(roleId).some(entity => entity.id === item.entity.id)
      }).map(item => {
        return item.entity
      }).sort(sortById)
    },
    availableEntitiesByRole: function (roleId) {
      // Roles to considerate are the own role id and all parents role id´s of that role
      let rolesToConsiderate = [roleId, ...this.subRoles.filter(role => role.subroles.some(r => r.id === roleId)).map(r => r.id)]
      let entityOptions = []
      if (this.clusters.length > 0) {
        let availableClusters = this.clusters.map(cluster => {
          cluster.entitiesWithRoles = this.filteredAuthUserRoles.some(r => {
            return r.entity_id === null
          }) && this.authUserRoles.some(r => rolesToConsiderate.includes(r.role_id) && r.entity_id === null) ? cluster.entitiesIds.length : this.getNumberEntitiesWithPermissions(cluster.entitiesIds, rolesToConsiderate)
          return cluster
        }).filter(cluster => {
          return cluster.entitiesWithRoles > 0
        })
        if (availableClusters.length > 0) {
          entityOptions.push({ name: this.$t('menu.clusters').toUpperCase(), $isDisabled: true })
          entityOptions = entityOptions.concat(availableClusters.map(cluster => {
            return {
              ...cluster,
              uid: `c${cluster.id}`
            }
          }))
          entityOptions.push({ name: this.$t('agenda.screenings.labels.entities').toUpperCase(), $isDisabled: true })
        }
      }
      let uniqueEntitiesIds = []
      // If I have a user role to any of the role ids to considerate and has entity id null return all entities
      if (this.authUserRoles.some(ur => rolesToConsiderate.some(item => item === ur.role_id) && ur.entity_id === null)) {
        entityOptions.push(...this.authEntities.filter(e => this.filteredAuthUserRoles.some(ur => ur.entity_id === e.id || ur.entity_id === null))
          .map(item => {
            return {
              ...item,
              uid: `e${item.id}`
            }
          }))
        return entityOptions
      }
      // For each roleId to considerate fetch entities that user can give to that roleId and group them together
      rolesToConsiderate.forEach((roleId) => {
        let datasetItem = this.datasetAvailableEntitiesByRole.find(item2 => item2.roleId === roleId)
        if (datasetItem) {
          let finalEntities = datasetItem.entitiesIds.filter(entityId => this.filteredAuthUserRoles.some(ur => ur.entity_id === null || ur.entity_id === entityId))
          uniqueEntitiesIds.push(...finalEntities)
        }
      })
      entityOptions.push(...this.authEntities.filter(entity => {
        return uniqueEntitiesIds.some(entityId => {
          return entityId === entity.id
        })
      }).map(entity => {
        return {
          ...entity,
          uid: `e${entity.id}`
        }
      }))
      return entityOptions
    },
    editUserEntityRole: function (userRole, selectedRow) {
      if (selectedRow !== this.editingRow) {
        this.isEditingEntity = true
        this.editingRow = selectedRow
        this.editingEntities = JSON.parse(JSON.stringify(userRole.entities))
        this.availableEntities = this.availableEntitiesByRole(userRole.id)
        this.editingEntities.forEach(entity => {
          if (!this.availableEntities.some(item => item.id === entity.id)) {
            this.availableEntities.push(entity)
          }
        })
      } else {
        this.isEditingEntity = !this.isEditingEntity
        this.editingRow = -1
      }
    },
    saveUserEntityRole: function (role) {
      let entitiesToSubmit = []
      let clustersSelected = this.editingEntities.filter(item => item.entities && Array.isArray(item.entities))
      if (clustersSelected.length > 0) {
        clustersSelected.forEach(cluster => {
          entitiesToSubmit.push(...cluster.entities.map(e => e.id))
        })
      }
      let entitiesSelected = this.editingEntities.filter(item => !item.entities)
      if (entitiesSelected.length > 0) {
        entitiesToSubmit.push(...entitiesSelected.map(e => e.id))
      }
      const formObject = {
        role_id: role.id,
        entities: [...new Set(entitiesToSubmit)]
      }
      this.$emit('updateUserRules', formObject)
      this.resetFields()
    },
    cancelEdit: function () {
      this.editingRow = -1
      this.isEditingEntity = false
    },
    resetFields: function () {
      this.editingRow = -1
      this.isEditingEntity = false
      this.editingEntities = []
    },
    closeEntitiesByRoleModal: function () {
      this.showFullEntities = false
    }
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
    canEdit: function () {
      return this.editable && !this.isViewMode
    },
    shouldDisplayViewAllOption: function () {
      let numberAvailableRoles = this.subRoles.length
      this.subRoles.forEach(role => {
        if (Array.isArray(role.subroles)) {
          numberAvailableRoles += role.subroles.length
        }
      })
      let numberRolesWithEntities = this.dataset.reduce((accumulator, datasetRow) => {
        if (datasetRow.entities.length) {
          return accumulator + 1
        }
        return accumulator
      }, 0)

      return numberAvailableRoles !== numberRolesWithEntities
    },
    selectedService: function () {
      return this.$store.getters.globalAuthService
    },
    filteredDataset: function () {
      let filteredDataset = this.dataset
      if (!this.viewAll && this.query === '') {
        filteredDataset = filteredDataset.filter(datasetItem => datasetItem.entities.length)
      }
      if (this.query !== '') {
        filteredDataset = filteredDataset.filter(item => {
          return item.name.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
        })
      }
      return filteredDataset
    },
    authUserRoles: function () {
      return this.selectedService.user_roles
    },
    authPermissions: function () {
      return this.selectedService.user_permissions
    },
    authRolesPermissions: function () {
      return this.authPermissions.filter(p => p.info_type === 100)
    },
    writeAuthRolesPermissions: function () {
      return this.authRolesPermissions.filter(p => p.access_type >= 2)
    },
    filteredAuthUserRoles: function () {
      return this.authUserRoles.filter(ur => {
        return this.writeAuthRolesPermissions.some(up => ur.entity_id === up.entity_id)
      })
    },
    authRoles: function () {
      return this.selectedService.roles
    },
    authEntities: function () {
      return this.selectedService.entities
    }
  },
  watch: {
    clusters: {
      handler (clusters) {
        this.clustersCopy = clusters
      }
    },
    roles: {
      handler () {
        this.generateDataset()
      },
      deep: true
    },
    query: debounce(function () {
      this.generateDataset()
    }, 500)
  }
}
</script>

<style lang="scss">
.tag-role{
  margin-right: 10px;
  margin-bottom: 0.5rem;
  padding: 0.4em 1em;
  background: #29c4a9;
  color: white;
  border-radius: 1em;
  font-weight: 100;
  font-size: 13px;
  white-space: nowrap;
}

.tag-role-clicable{
  cursor:pointer;
}

.multiselect .multiselect__tag {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight::after {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--selected {
  background-color: #d9d9d9;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight {
  background-color: #e34a4a;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight::after {
  background-color: #e34a4a;
}

.btn-action-role{
  padding: 0.6rem 1.45rem !important;
  letter-spacing: 1px !important;
  font-size: 9px !important;
}

.multiselect__clear {
  position: absolute;
  right: 33px;
  height: 30px;
  width: 30px;
  display: block;
  cursor: pointer;
  z-index: 2;
}

.multiselect__clear:after, .multiselect__clear:before {
  content: "";
  display: block;
  position: absolute;
  width: 3px;
  height: 12px;
  background: #C0C0C0;
  top: 15px;
  right: 4px;
}

.multiselect__clear:after {
  transform: rotate(-45deg);
}

.multiselect__clear:before {
  transform: rotate(45deg);
}

.custom__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #29c4a9;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  cursor: pointer;
}

.custom__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  border-radius: 5px;
}

.custom__tag-icon:focus, .custom__tag_removable-icon:hover {
  background: #21ab93;
}

.custom__tag-icon:after {
  content: "\D7";
  color: #266d4d;
  font-size: 14px;
}

.custom__tag-icon:focus:after, .custom__tag-icon:hover:after {
  color: #fff;
}

/* table {
  display: flex;
  flex-flow: column;
  width: 100%;
}

thead {
  flex: 0 0 auto;
}

tbody {
  max-height: 475px;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
}

tr {
  width: 100%;
  display: flex;
  align-items:center;
  /*table-layout: fixed;
} */

.tag__role__item {
  flex-grow: 1;
}

.dataset__label {
  min-width: 30%;
}
</style>
